import { z } from 'zod';
/** Rückgabe einer angenommenen Fahrt durch den Fahrer: Der Grund ist Pflicht, das Büro sieht ihn im Verlauf des Auftrags */
export const releaseRideInput = z.object({ reason: z.string().trim().min(3, 'Bitte nennen Sie den Grund der Rückgabe').max(300, 'Höchstens 300 Zeichen') }).strict();
//# sourceMappingURL=rides.js.map